import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { LottieTest } from './components/LottieTest/LottieTest'
import { AvatarAnimationProvider } from './contexts/AvatarAnimationContext'
import './index.css'

// Manejador global de errores para suprimir errores no críticos de extensiones del navegador
window.addEventListener('unhandledrejection', (event) => {
  // Suprimir el error común de extensiones del navegador que no afecta la funcionalidad
  if (event.reason && typeof event.reason === 'object' && 'message' in event.reason) {
    const errorMessage = String(event.reason.message);
    if (errorMessage.includes('message channel closed before a response was received')) {
      event.preventDefault(); // Prevenir que el error aparezca en la consola
      return;
    }
    // Suprimir errores de conexión a localhost (telemetría de desarrollo)
    if (errorMessage.includes('ERR_CONNECTION_REFUSED') || 
        errorMessage.includes('127.0.0.1') ||
        errorMessage.includes('localhost')) {
      event.preventDefault();
      return;
    }
  }
  // Para otros errores, permitir que se muestren normalmente
});

// Interceptor global para bloquear llamadas a localhost en producción
if (import.meta.env.PROD) {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    let url = '';
    if (typeof args[0] === 'string') {
      url = args[0];
    } else if (args[0] instanceof Request) {
      url = args[0].url;
    } else if (args[0] instanceof URL) {
      url = args[0].toString();
    }
    // Bloquear cualquier llamada a localhost o 127.0.0.1
    if (url && (url.includes('127.0.0.1') || url.includes('localhost:') || url.includes('localhost/'))) {
      // Silenciosamente rechazar sin mostrar error en consola
      return Promise.reject(new Error('Connection to localhost blocked in production'));
    }
    return originalFetch.apply(this, args);
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {window.location.search.includes('test=lottie') ? (
      <LottieTest />
    ) : (
      <AvatarAnimationProvider>
        <App />
      </AvatarAnimationProvider>
    )}
  </React.StrictMode>,
)
